import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Card, Avatar, Button } from 'antd';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, InputAdornment, IconButton, Button as MUIButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { isAuthenticated } from '../../../../services/auth';
import { updatePassword } from '../../../../services/user';

const { Meta } = Card;

const AdminSidebar = () => {
  const { user, token } = isAuthenticated();
  const history = useHistory();
  const [passwordModalOpen, setPasswordModalOpen] = useState(false);
  const [passwordForm, setPasswordForm] = useState({
    newPassword: '',
    confirmPassword: '',
  });
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loadingPassword, setLoadingPassword] = useState(false);

  const logout = () => {
    window.localStorage.removeItem('buynsell');
    history.push('/login');
    window.location.reload();
  };

  const handlePasswordChange = (field) => (event) => {
    setPasswordForm({ ...passwordForm, [field]: event.target.value });
  };

  const handlePasswordSubmit = async () => {
    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      alert('As senhas não coincidem');
      return;
    }
    setLoadingPassword(true);
    try {
      await updatePassword(user._id, {
        password: passwordForm.newPassword,
        newPasswordConfirm: passwordForm.confirmPassword,
      }, token);
      alert('Senha alterada com sucesso');
      setPasswordModalOpen(false);
      setPasswordForm({ newPassword: '', confirmPassword: '' });
    } catch (err) {
      alert('Erro ao alterar senha: ' + (err.response?.data?.error || err.message));
    } finally {
      setLoadingPassword(false);
    }
  };

  return (
    <div className="admin-sidebar admin-sidebar-container">
      {/* User Profile Card */}
      <Card className="admin-sidebar-profile-card">
        <Meta
          avatar={
            <Avatar
              src={user.photo ? `${process.env.REACT_APP_API?.replace(/\/api$/, '')}${user.photo.replace(/^[\.\/]playnoimovel\.com\.br\/api/, '')}` : null}
              className='shadow-modern admin-sidebar-avatar'
              size={80}
            >
              {user.name?.[0]?.toUpperCase() || 'A'}
            </Avatar>
          }
          title={user.name || 'Administrador'}
          description={
            <>
              <p className="text-muted mb-0 small">
                <i className="fas fa-at me-1"></i>
                {user.username || 'admin'}
              </p>
              <p className="text-muted mb-0 small">
                <i className="fas fa-phone me-1"></i>
                {user.phone || 'Não informado'}
              </p>
            </>
          }
        />
      </Card>

      {/* Navigation Menu */}
      <div className="modern-card">
        <div className="modern-card-body p-0">
          <nav className="nav flex-column">
            <Link 
              to='/admin/dashboard' 
              className='nav-link d-flex align-items-center gap-3 px-3 py-3 text-decoration-none border-bottom admin-sidebar-nav-link'
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = 'var(--primary-light)';
                e.target.style.color = 'var(--primary-color)';
                e.target.style.transform = 'translateX(4px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = 'var(--gray-700)';
                e.target.style.transform = 'translateX(0)';
              }}
            >
              <div className="d-flex align-items-center justify-content-center rounded-circle admin-sidebar-icon-circle admin-sidebar-icon-circle-dashboard">
                <i className='fas fa-tachometer-alt admin-sidebar-icon admin-sidebar-icon-dashboard'></i>
              </div>
              <span className="fw-medium admin-sidebar-link-text">Dashboard</span>
            </Link>

            <Link 
              to='/user/dashboard' 
              className='nav-link d-flex align-items-center gap-3 px-3 py-3 text-decoration-none border-bottom admin-sidebar-nav-link'
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#f0fdf4';
                e.target.style.color = '#10b981';
                e.target.style.transform = 'translateX(4px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = 'var(--gray-700)';
                e.target.style.transform = 'translateX(0)';
              }}
            >
              <div className="d-flex align-items-center justify-content-center rounded-circle admin-sidebar-icon-circle admin-sidebar-icon-circle-user">
                <i className='fas fa-user admin-sidebar-icon admin-sidebar-icon-user'></i>
              </div>
              <span className="fw-medium admin-sidebar-link-text">Perfil do Usuário</span>
            </Link>

            <Link 
              to='/admin/add-category' 
              className='nav-link d-flex align-items-center gap-3 px-3 py-3 text-decoration-none border-bottom admin-sidebar-nav-link'
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#fef3c7';
                e.target.style.color = '#f59e0b';
                e.target.style.transform = 'translateX(4px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = 'var(--gray-700)';
                e.target.style.transform = 'translateX(0)';
              }}
            >
              <div className="d-flex align-items-center justify-content-center rounded-circle admin-sidebar-icon-circle admin-sidebar-icon-circle-category">
                <i className='fas fa-tags admin-sidebar-icon admin-sidebar-icon-category'></i>
              </div>
              <span className="fw-medium admin-sidebar-link-text">Categorias</span>
            </Link>

            <Link 
              to='/admin/add-location' 
              className='nav-link d-flex align-items-center gap-3 px-3 py-3 text-decoration-none border-bottom admin-sidebar-nav-link'
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#f3e8ff';
                e.target.style.color = '#8b5cf6';
                e.target.style.transform = 'translateX(4px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = 'var(--gray-700)';
                e.target.style.transform = 'translateX(0)';
              }}
            >
              <div className="d-flex align-items-center justify-content-center rounded-circle admin-sidebar-icon-circle admin-sidebar-icon-circle-location">
                <i className='fas fa-map-marker-alt admin-sidebar-icon admin-sidebar-icon-location'></i>
              </div>
              <span className="fw-medium admin-sidebar-link-text">Localizações</span>
            </Link>

            <Link 
              to='/admin/users' 
              className='nav-link d-flex align-items-center gap-3 px-3 py-3 text-decoration-none border-bottom admin-sidebar-nav-link'
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#ede9fe';
                e.target.style.color = '#7c3aed';
                e.target.style.transform = 'translateX(4px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = 'var(--gray-700)';
                e.target.style.transform = 'translateX(0)';
              }}
            >
              <div className="d-flex align-items-center justify-content-center rounded-circle admin-sidebar-icon-circle admin-sidebar-icon-circle-users">
                <i className='fas fa-users admin-sidebar-icon admin-sidebar-icon-users'></i>
              </div>
              <span className="fw-medium admin-sidebar-link-text">Usuários</span>
            </Link>

            <Link 
              to='/admin/sponsored-ads' 
              className='nav-link d-flex align-items-center gap-3 px-3 py-3 text-decoration-none border-bottom admin-sidebar-nav-link'
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#fef3c7';
                e.target.style.color = '#d97706';
                e.target.style.transform = 'translateX(4px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = 'var(--gray-700)';
                e.target.style.transform = 'translateX(0)';
              }}
            >
              <div className="d-flex align-items-center justify-content-center rounded-circle admin-sidebar-icon-circle admin-sidebar-icon-circle-sponsored">
                <i className='fas fa-star admin-sidebar-icon admin-sidebar-icon-sponsored'></i>
              </div>
              <span className="fw-medium admin-sidebar-link-text">Anúncios Patrocinados</span>
            </Link>

            <Link 
              to='/admin/reported-products' 
              className='nav-link d-flex align-items-center gap-3 px-3 py-3 text-decoration-none border-bottom admin-sidebar-nav-link'
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#fee2e2';
                e.target.style.color = '#dc2626';
                e.target.style.transform = 'translateX(4px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = 'var(--gray-700)';
                e.target.style.transform = 'translateX(0)';
              }}
            >
              <div className="d-flex align-items-center justify-content-center rounded-circle admin-sidebar-icon-circle admin-sidebar-icon-circle-reported">
                <i className='fas fa-flag admin-sidebar-icon admin-sidebar-icon-reported'></i>
              </div>
              <span className="fw-medium admin-sidebar-link-text">Produtos Denunciados</span>
            </Link>

            <div 
              onClick={() => setPasswordModalOpen(true)}
              className='nav-link d-flex align-items-center gap-3 px-3 py-3 text-decoration-none border-bottom admin-sidebar-nav-link'
              style={{ cursor: 'pointer' }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#dbeafe';
                e.target.style.color = '#2563eb';
                e.target.style.transform = 'translateX(4px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = 'var(--gray-700)';
                e.target.style.transform = 'translateX(0)';
              }}
            >
              <div className="d-flex align-items-center justify-content-center rounded-circle admin-sidebar-icon-circle admin-sidebar-icon-circle-password">
                <i className='fas fa-key admin-sidebar-icon admin-sidebar-icon-password'></i>
              </div>
              <span className="fw-medium admin-sidebar-link-text">Trocar Senha</span>
            </div>

            <Button 
              className='nav-link d-flex align-items-center gap-3 px-3 py-3 text-decoration-none border-0 bg-transparent w-100 admin-sidebar-logout-btn'
              onClick={logout}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#fee2e2';
                e.target.style.color = '#dc2626';
                e.target.style.transform = 'translateX(4px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = 'var(--gray-700)';
                e.target.style.transform = 'translateX(0)';
              }}
            >
              <div className="d-flex align-items-center justify-content-center rounded-circle admin-sidebar-icon-circle admin-sidebar-icon-circle-logout">
                <i className='fas fa-sign-out-alt admin-sidebar-icon admin-sidebar-icon-logout'></i>
              </div>
              <span className="fw-medium admin-sidebar-link-text">Sair</span>
            </Button>
          </nav>
        </div>
      </div>

      {/* Password Change Modal */}
      <Dialog
        open={passwordModalOpen}
        onClose={() => setPasswordModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Trocar Senha</DialogTitle>
        <DialogContent>
          <TextField
            label="Nova Senha"
            type={showNewPassword ? 'text' : 'password'}
            fullWidth
            margin="normal"
            value={passwordForm.newPassword}
            onChange={handlePasswordChange('newPassword')}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowNewPassword(!showNewPassword)}
                    edge="end"
                  >
                    {showNewPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Confirmar Nova Senha"
            type={showConfirmPassword ? 'text' : 'password'}
            fullWidth
            margin="normal"
            value={passwordForm.confirmPassword}
            onChange={handlePasswordChange('confirmPassword')}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    edge="end"
                  >
                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </DialogContent>
        <DialogActions>
          <MUIButton onClick={() => setPasswordModalOpen(false)} disabled={loadingPassword}>
            Cancelar
          </MUIButton>
          <MUIButton onClick={handlePasswordSubmit} variant="contained" disabled={loadingPassword}>
            {loadingPassword ? 'Alterando...' : 'Alterar Senha'}
          </MUIButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AdminSidebar;
